export default {
  title: 'Belastinggegevens',
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    success: 'Gegevens succesvol opgeslagen.',
  },
};
